import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  cloneScenario,
  fetchAllScenarios
} from '../../../../redux/actions/trm/trmDashboard';
import Summary from './Summary';
import {
  fetchTypologiesActions,
  fetchAMLSAlertLevel
} from '../../../../redux/actions/common';

function mapStateToProps(state) {
  const { trmDashboard = {}, amlsCommon = {} } = state;
  const { allScenarios = {}, triggeredScenarioStatus = {} } = trmDashboard;
  const { isLoading, data, error } = allScenarios;
  return {
    isLoading,
    error,
    scenarios: data,
    triggeredScenarioStatus,
    authentication: state.authentication.data,
    trmActions: amlsCommon.commonTypologyAction,
    alertLevels: amlsCommon.alertLevelConfigs?.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    summaryAPIActions: bindActionCreators(
      {
        fetchAllScenarios,
        cloneScenario,
        fetchTypologiesActions,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Summary)
);
